import { z } from 'zod';

export type WeeklyReportDataQuery = z.output<typeof weeklyReportDataQuerySchema>;
export type WeeklyReportDataQueryDTO = z.input<typeof weeklyReportDataQuerySchema>;

export const weeklyReportDataQuerySchema = z.object({
  playerIds: z.union([z.uuid(), z.array(z.uuid())]).catch([]),
  groupId: z.uuid().nullable().catch(null),
});
